export default {
    address: 'Email Address',
    familyName: 'Last Name',
    givenName: 'First Name',
    info: {
        goToYourEmailSettings:
            'Please go to your <0>email settings</0> to change both.',
        noteThatEditing:
            "Note that editing this team member's name will not change the sender's contact information in previously created documents.",
        notificationsAboutEvents:
            'Notifications about events in <0>{{company}}</0> will be sent to <0>{{email}}.</0>',
        userNotifications:
            'User notifications will be sent to your primary email address <0>{{email}}</0>.',
    },
    sendingSignature: 'Sender Signature',
    submit: 'Save Team Member',
};
